
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import avt from "../../assets/images/Default_user_image.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "../../API/axios";
// import Notification from '../NotificationPage/Notification';
// import { Notification } from '../NotificationPage/Notification';
import Notification from '../../khojpages/NoticationPage/Notification';
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
// import SampleCV from "../../pages/SampleCV";
// import Blog_v1 from "../../pages/Blog_v1";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import { SearchOutlined } from "@mui/icons-material";
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import DashboardSharpIcon from '@mui/icons-material/DashboardSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import SettingsSharpIcon from '@mui/icons-material/SettingsSharp';

import NotificationsSharpIcon from '@mui/icons-material/NotificationsSharp';
import GobalSearch from "../../khojpages/GlobalSearch/GobalSearch";
import TopNotification from "./TopNotification";


InstituteHeader.propTypes = {};


function InstituteHeader({ clname = "", handleMobile }) {
    const [isDark, setIsDark] = useLocalStorage("isDark", false);
    const [profileImage, setProfileImage] = useState(localStorage.getItem("ProfileImage") || "default-profile.png");

    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, []);

    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = (path) => {
        if (location.pathname === path) {
            window.location.reload(); // Force a full page reload
        } else {
            navigate(path);
        }
    };
    // ..................................................................................
    // ..................................................................................
    // Get the sessionId from localStorage
    const sessionId = localStorage.getItem("sessionId");
    // const profileImage = localStorage.getItem("profilPic");
    // const [profileImage, setProfileImage] = useState(localStorage.getItem("profilPic") || "default-profile.png"); // Default image

    // const profileImage = localStorage.getItem("profilePic");

    // Initialize state variables for notifications and notification count
    const [notifi, setNotifi] = useState([]);
    const [notifiCount, setNotifiCount] = useState("");




    // Async function to get the top 5 notifications
    const NotificationList = async () => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,  // sessionId from localStorage
        };

        try {
            // Make the POST request to the server
            const resData = await axios.post(`V1/General/GetTop5Notifications`, data);

            // Log the response data to the console
            console.log("Response Data:", resData.data.responseData);

            // Set the notifications state with the response data
            setNotifi(resData.data.responseData);

            // Optionally, log the state update to check if notifications were set correctly
            console.log("Notifications after set:", notifi);
        } catch (error) {
            // Handle error if the server returns a 404 status
            if (error.response && error.response.status === 404) {
                console.log("Error 404: Not Found");
            } else {
                // Log any other error
                console.log(error);
            }
        }
    };


    // Example data for each tab
    const [activeTab, setActiveTab] = useState('notification'); // Active tab tracking
    const notifications = [
        { time: 'Last day', content: 'Your submit job Graphic Design is Success' },
        { time: '5 Days ago', content: 'A new application is submitted on your job Graphic Design by Maverick Nguyen' },
    ];

    const alertjobs = [
        { time: 'Last day', content: 'Your Graphic Design job has been posted successfully' },
        { time: '3 Days ago', content: 'Another applicant applied for Graphic Design' },
    ];

    const Interviews = [
        { time: 'Yesterday', content: 'Your interview for Graphic Design is scheduled for tomorrow' },
    ];

    const dismissNotification = (id, setState) => {
        setState((prev) => prev.filter((item) => item.id !== id));
    };

    // Function to render content based on the selected tab
    const renderContent = (items, setState) =>
        items.map((item, index) => (
            <div key={index} className=" ">
                <div className="mt-1">
                    <div className="sub-notification-content">
                        <div className="sub-notification-item icon-plus">
                            <div className="time Notification-Text">{item.time}</div>
                            <div className="content Notification-Text">
                                {item.content}
                                {/* <span className="name">Graphic Design</span> is&nbsp;
                          <span className="status">Success</span> */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>


        ));

    const [userData, setUserData] = useState({
        entityName: "",
        email: "",
        userType: "",
        profilPic: "",
        userUID: ""
    });

    useEffect(() => {
        const entityName = localStorage.getItem("entityName");
        const email = localStorage.getItem("email");
        const userType = localStorage.getItem("userType");
        const userUID = localStorage.getItem("userUID");
        const profilPic = localStorage.getItem("profilPic");

        setUserData({ entityName, email, userType, profilPic, userUID });
    }, []);

    


    // ........................................................................
    // ........................................................................
    return (
        <>
            <header
                id="header"
                className={`header khojdesktopHeader pt-3 header-default loginkhojHeader`}
            >
                <div className="px-4 ct2">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="sticky-area-wrap">
                                <div className="header-ct-left">
                                    {isDark ? (
                                        <div id="logo" className="logo">
                                            <Link to="/Home" onClick={() => handleNavigation("/Home")}>
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={logo2}
                                                    alt="Image"
                                                />
                                            </Link>
                                        </div>
                                    ) : (
                                        <div id="logo" className="logo">
                                            <Link to="/Home" onClick={() => handleNavigation("/Home")}>
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={logo}
                                                    alt="Image"
                                                />
                                            </Link>
                                        </div>
                                    )}
                                </div>
                                <div className="form-group-1 khojSearch d-flex align-items-center">

                                    <GobalSearch />
                                </div>
                                <div className="header-ct-center">
                                    <div className="nav-wrap">
                                        <nav id="main-nav" className="main-nav">
                                            <ul id="menu-primary-menu" className={`menu mb-2 ${clname}`}>


                                            <li className="menu-item subjob">
                                                    <Link to="/Jobs"  >
                                                        <WorkSharpIcon className="pointer" />
                                                    </Link>
                                                    <NavLink to="/Jobs">Jobs</NavLink>
                                                </li>
                                                <li className="menu-item menu-item-has-children sub4 me-4">
                                                    <Link>
                                                        <AccountCircleSharpIcon className="pointer" />
                                                    </Link>
                                                    <Link>Manage</Link>

                                                    <ul className="dropdown-menu sub-menu st1 candidate-menu">
                                                        <Link to="/Manage-class"  >
                                                            <li className="dropdown-item">
                                                                <NavLink to="/Manage-class">
                                                                    Manage Class
                                                                </NavLink>
                                                            </li>
                                                        </Link>
                                                        <Link to="/Institute/Candidate/All"  >
                                                            <li className="dropdown-item">
                                                                <NavLink to="/Institute/Candidate/All">
                                                                    Manage Candidate
                                                                </NavLink>
                                                            </li>
                                                        </Link>
                                                        <Link to="/Institute/Candidate/Add"  >
                                                            <li className="dropdown-item">
                                                                <NavLink to="/Institute/Candidate/Add">
                                                                    Add Candidate
                                                                </NavLink>
                                                            </li>
                                                        </Link>
                                                        <Link to="/Institute/Candidate/ManageInterview"  >
                                                            <li className="dropdown-item">
                                                                <NavLink to="/Institute/Candidate/ManageInterview">
                                                                    Manage Test
                                                                </NavLink>
                                                            </li>
                                                        </Link>
                                                    </ul>
                                                </li>
                                              


                                                <li className="menu-item menu-item-has-children sub4">
                                                    <Link>
                                                        <WorkHistorySharpIcon />
                                                    </Link>
                                                    <Link to="#">Manage Job</Link>

                                                    <ul className="dropdown-menu sub-menu st1">
                                                        <Link to="/Saved-jobs" >
                                                            <li className="dropdown-item">
                                                                <Link to="/Saved-jobs" >Saved Jobs</Link>
                                                            </li>
                                                        </Link>
                                                        <Link to="/Applied-jobs"  >
                                                            <li className="dropdown-item">
                                                                <NavLink to="/Applied-jobs">Applied Jobs</NavLink>
                                                            </li>
                                                        </Link>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div className="header-ct-right">
                                    <Toggle
                                        isChecked={isDark}
                                        handleChange={() => setIsDark(!isDark)}
                                    />
                                    <TopNotification />




                                    <div className="nav-wrap">
                                        <nav id="main-nav" className="main-nav">
                                            <ul id="menu-primary-menu" className={`menu profileMenu mb-2 p-0 ${clname}`}>


                                                <li className="menu-item menu-item-has-children profile-img m-0">
                                                    {/* <Link to="#"> */}
                                                    <img
                                                        //  src={userData.profilPic}
                                                        src={profileImage}
                                                        width={40}
                                                        //  alt="User Logo"
                                                        className="userProfileHeader " />
                                                    {/* </Link> */}

                                                    <div className="header-customize-item bell pro  ">
                                                        <div className="sub-notification profile">
                                                            <div className="tabs row">
                                                                <li>
                                                                    <div className=" d-flex HeaderFLName">
                                                                        <h6> {`${userData.entityName} `}</h6>
                                                                    </div >
                                                                    <div className="HeaderEmail" >
                                                                        <h6> {userData.email}</h6>
                                                                    </div>
                                                                    <div className="HeaderUserType">
                                                                        <h6> {userData.userType}</h6>
                                                                    </div>
                                                                </li>
                                                                <li className="nav-sub">
                                                                    <AccountCircleSharpIcon />
                                                                    <Link to={`/${userData.userType}/${userData.userUID}`}  >
                                                                        Profile
                                                                    </Link>

                                                                </li>
                                                                <li className="nav-sub">
                                                                    <SettingsSharpIcon />
                                                                    <NavLink to="/Settings" >
                                                                        Settings
                                                                    </NavLink>
                                                                </li>
                                                                <li className="nav-sub" >
                                                                    <LogoutSharpIcon />
                                                                    <NavLink
                                                                        to="/Login"
                                                                        onClick={() => {
                                                                            const isDarkValue = localStorage.getItem('isDark'); // Store the value of isDark
                                                                            localStorage.clear(); // Clear all localStorage
                                                                            if (isDarkValue !== null) {
                                                                                localStorage.setItem('isDark', isDarkValue); // Restore the isDark key if it exists
                                                                            }
                                                                        }}
                                                                    >
                                                                        Logout
                                                                    </NavLink>
                                                                </li>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div className="nav-filter" onClick={handleMobile}>
                                    <div className="nav-mobile">
                                        <span></span>
                                    </div>
                                </div>

                                {/* <div className="" style={{ margin: '5px' }}>
                <Link to="/forgetpassword">
                  <button>Forget</button>
                </Link>

              </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <header
                id="header"
                className={`header khojmobileHeader pt-3 header-default loginkhojHeader `}
            >
                <div className="px-4 ct2">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="sticky-area-wrap">
                                <div className="header-ct-left">
                                    <div className="nav-wrap">
                                        <nav id="main-nav" className="main-nav profileNav">
                                            <ul id="menu-primary-menu" className={`menu profileMenu mb-2 ${clname} Nav-Header-Mobile mt-1`}>
                                                <div className="nav-filter" onClick={handleMobile}>
                                                    <div className="nav-mobile">
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </ul>
                                        </nav>
                                    </div>

                                </div>
                                <div className="form-group-1 khojSearch d-flex align-items-center">
                                    <GobalSearch />

                                </div>
                                <div className="header-ct-right">
                                    <TopNotification />
                                    <div className="ms-auto me-2 mobileToggle">
                                        <Toggle
                                            isChecked={isDark}
                                            handleChange={() => setIsDark(!isDark)}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default InstituteHeader;







